"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.abortedPromise = exports.ABORT_REASON = void 0;
exports.ABORT_REASON = "promise be aborted";
function abortedPromise(originPromise) {
    var abortFunc = null;
    var abortPromise = new Promise(function (_resolve, reject) {
        abortFunc = function () {
            reject(exports.ABORT_REASON);
        };
    });
    var promiseChain = Promise.race([originPromise, abortPromise]);
    promiseChain.abort = abortFunc;
    return promiseChain;
}
exports.abortedPromise = abortedPromise;
